<div class="toast" [ngClass]="toastrService.toastrConfig.toastClass" [style.display]="state.value === 'inactive' ? 'none' : ''">
  <div class="toast-icon-container">
    <img
      *ngIf="toastrService.toastrConfig.toastClass !== 'none'"
      class="toast-icon"
      [src]="'assets/img/' + toastrService.toastrConfig.toastClass + '.png'"
      [attr.alt]="toastrService.toastrConfig.toastClass"
    />
  </div>

  <div class="toast-text-container">
    <div class="toast-header" *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title" [innerHTML]="title"></div>

    <div
      class="toast-body"
      *ngIf="message"
      role="alert"
      aria-live="polite"
      [class]="options.messageClass"
      [attr.aria-label]="message"
      [innerHTML]="message"
    ></div>
  </div>
  <button *ngIf="options.closeButton" (click)="remove()" class="toast-close-button" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width - 15 + '%'"></div>
</div>
